import mapImg from "../../../assets/map.png";

// Explore Images
import newApartmentsImg from "../../../assets/new_homes/explore/new-apartments.jpg";
import landEstatesImg from "../../../assets/new_homes/explore/land-estates.jpg";
import houseLandImg from "../../../assets/new_homes/explore/house-land.jpg";
import buildersImg from "../../../assets/new_homes/explore/builders.jpg";
import homeDesignsImg from "../../../assets/new_homes/explore/home-designs.jpg";

// New Apartments Images
import victoriaIslandImg from "../../../assets/new_homes/new-apartments/victoria-island.jpg";
import ikoyiImg from "../../../assets/new_homes/new-apartments/ikoyi.jpg";
import lekkiImg from "../../../assets/new_homes/new-apartments/lekki.jpg";
import lagosIslandImg from "../../../assets/new_homes/new-apartments/lagos-island.jpg";
import abujaImg from "../../../assets/new_homes/new-apartments/abuja.jpg";
import portHarcourtImg from "../../../assets/new_homes/new-apartments/port-harcourt.jpg";
import surulereImg from "../../../assets/new_homes/new-apartments/surulere.jpg";

// Land Estates Images
import epeImg from "../../../assets/new_homes/land/epe.jpg";
import ibejuLekkiImg from "../../../assets/new_homes/land/ibeju-lekki.jpg";
import moweImg from "../../../assets/new_homes/land/mowe.jpeg";
import abujaLandImg from "../../../assets/new_homes/land/abuja-land.jpg";
import ibadanImg from "../../../assets/new_homes/land/ibadan.jpg";
import enuguImg from "../../../assets/new_homes/land/enugu.jpg";
import sangotedoImg from "../../../assets/new_homes/land/sangotedo.webp";

// House & Land Images
import abeokutaHouseLandImg from "../../../assets/new_homes/house-land/abeokuta.jpeg";
import ajahHouseLandImg from "../../../assets/new_homes/house-land/ajah.jpg";
import asabaHouseLandImg from "../../../assets/new_homes/house-land/asaba.jpg";
import calabarHouseLandImg from "../../../assets/new_homes/house-land/calabar.jpg";
import ikejaHouseLandImg from "../../../assets/new_homes/house-land/Ikeja.jpg";
import maitamaHouseLandImg from "../../../assets/new_homes/house-land/maitma.jpeg";
import wuseHouseLandImg from "../../../assets/new_homes/house-land/wuse.jpg";
import uyoHouseLandImg from "../../../assets/new_homes/house-land/uyo.jpg";


// Unsplash CDN helper
const img = (id) =>
  `https://images.unsplash.com/photo-${id}?w=420&h=280&fit=crop&auto=format&q=80`;

// Verified Unsplash photo IDs — Nigerian cities & real estate
const IMGS = {
  // Lagos
  lagosAerial: img("1744907895363-d351aa6019ef"), // aerial Lekki, Lagos
  lagosIsland: img("1640475168872-4d8635675fc1"), // Lagos Island skyline
  lagosSunset: img("1640475167390-619167cd944d"), // Lagos sunset buildings
  lagosStreet: img("1648023199223-25d3622bcb13"), // Lagos busy street
  lagosHighrise: img("1543414347-1c348021f279"),   // white high-rise Lagos
  // Abuja
  abuja: img("1538525057649-4683c9484eaa"), // Abuja city
  abujaStreet: img("1659622439935-6c570f2dfb34"), // Abuja sunset street
  // Nigeria other
  nigeriaWater: img("1678652225243-8445e7535e36"), // sunset over water Nigeria
  nigeriaHouses: img("1537372023620-37161b1ad8ac"), // assorted houses Nigeria
  // Real estate / construction / interiors
  houseExterior: img("1560518883-ce09059eeffa"),   // modern house exterior
  modernHome: img("1564013799919-ab600027ffc6"), // modern home
  apartments: img("1545324418-cc1a3fa10c00"),   // apartment building
  luxuryHome: img("1580587771525-78b9dba3b914"), // luxury home
  construction1: img("1571055107559-3e67626fa8be"), // construction site
  construction2: img("1504307651254-35680f356dfd"), // construction work
  interior: img("1503174971373-b1f69850bdd0"), // home interior design
  aerialLand: img("1448630360428-65456885c650"), // aerial neighborhood/land
};

export const nigeriaStates = [
  "Lagos", "FCT Abuja", "Rivers", "Kano", "Oyo",
];

export const categoryTabs = [
  { label: "Explore", path: "/new-homes/explore" },
  { label: "New Apartments", path: "/new-homes/results" },
  { label: "Land", path: "/new-homes/land" },
  { label: "House & Land", path: "/new-homes/results" },
  { label: "Builders", path: "/new-homes/builders" },
  { label: "Home Designs", path: "/new-homes/home-designs" },
];

export const tabHeadings = {
  Explore: {
    title: "New homes start here.",
    subtitle: "Explore new apartments, land estates, house and land, home designs, builders and more.",
    showDropdown: false,
  },
  "New Apartments": {
    prefix: "New apartments in",
    bold: "New South Wales",
    showDropdown: true,
    subtitle: null,
  },
  Land: {
    prefix: "New land estates in",
    bold: "New South Wales",
    showDropdown: true,
    subtitle: null,
  },
  "House & Land": {
    title: "House and Land Packages in Nigeria",
    showDropdown: false,
    subtitle: null,
  },
  Builders: {
    title: "Home Builders in Nigeria",
    showDropdown: false,
    subtitle: null,
  },
  "Home Designs": {
    title: "Home Designs in Nigeria",
    showDropdown: false,
    subtitle: null,
  },
};

export const tabLocations = {
  Explore: {
    title: "Explore all new homes in Nigeria",
    cards: [
      { id: 1, image: newApartmentsImg, title: "New Apartments" },
      { id: 2, image: landEstatesImg, title: "Land Estates" },
      { id: 3, image: houseLandImg, title: "House & Land" },
      { id: 4, image: buildersImg, title: "Builders" },
      { id: 5, image: homeDesignsImg, title: "Home Designs" },
    ],
  },
  "New Apartments": {
    title: "Top locations for new apartments & off the plan properties in Nigeria",
    cards: [
      { id: 1, image: mapImg, title: "Explore Map", isMap: true },
      { id: 2, image: victoriaIslandImg, title: "Victoria Island" },
      { id: 3, image: ikoyiImg, title: "Ikoyi" },
      { id: 4, image: lekkiImg, title: "Lekki" },
      { id: 5, image: lagosIslandImg, title: "Lagos Island" },
      { id: 6, image: abujaImg, title: "Abuja" },
      { id: 7, image: portHarcourtImg, title: "Port Harcourt" },
      { id: 8, image: surulereImg, title: "Surulere" },
    ],
  },
  Land: {
    title: "Top areas for new land estates in Nigeria",
    cards: [
      { id: 1, image: mapImg, title: "Explore Map", isMap: true },
      { id: 2, image: epeImg, title: "Epe" },
      { id: 3, image: ibejuLekkiImg, title: "Ibeju-Lekki" },
      { id: 4, image: moweImg, title: "Mowe" },
      { id: 5, image: abujaLandImg, title: "Abuja" },
      { id: 6, image: ibadanImg, title: "Ibadan" },
      { id: 7, image: enuguImg, title: "Enugu" },
      { id: 8, image: sangotedoImg, title: "Sangotedo" },
    ],
  },
  "House & Land": {
    title: "Discover new homes, house and land packages in Nigeria.",
    cards: [
      { id: 1, image: ikejaHouseLandImg, title: "Ikeja" },
      { id: 2, image: ajahHouseLandImg, title: "Ajah" },
      { id: 3, image: maitamaHouseLandImg, title: "Maitama" },
      { id: 4, image: wuseHouseLandImg, title: "Wuse" },
      { id: 5, image: asabaHouseLandImg, title: "Asaba" },
      { id: 6, image: uyoHouseLandImg, title: "Uyo" },
      { id: 7, image: abeokutaHouseLandImg, title: "Abeokuta" },
      { id: 8, image: calabarHouseLandImg, title: "Calabar" },
    ],
  },
  Builders: {
    title: "Find a builder to design and build your dream home",
    cards: [
      { id: 1, image: IMGS.lagosStreet, title: "Kano" },
      { id: 2, image: IMGS.lagosAerial, title: "Kaduna" },
      { id: 3, image: IMGS.nigeriaWater, title: "Jos" },
      { id: 4, image: IMGS.construction1, title: "Benin City" },
      { id: 5, image: IMGS.construction2, title: "Abeokuta" },
      { id: 6, image: IMGS.abujaStreet, title: "Akure" },
      { id: 7, image: IMGS.lagosHighrise, title: "Ilorin" },
      { id: 8, image: IMGS.modernHome, title: "Warri" },
    ],
  },
  "Home Designs": {
    title: "Explore home designs across Nigeria",
    cards: [
      { id: 1, image: IMGS.lagosIsland, title: "Owerri" },
      { id: 2, image: IMGS.lagosSunset, title: "Yenagoa" },
      { id: 3, image: IMGS.modernHome, title: "Onitsha" },
      { id: 4, image: IMGS.lagosIsland, title: "Awka" },
      { id: 5, image: IMGS.lagosSunset, title: "Ado Ekiti" },
      { id: 6, image: IMGS.abujaStreet, title: "Osogbo" },
      { id: 7, image: IMGS.luxuryHome, title: "Lokoja" },
      { id: 8, image: IMGS.lagosAerial, title: "Minna" },
    ],
  },
};

